import * as ExcelJS from 'exceljs';
import { CustomField } from '../../../../interfaces/Settings';
import Swal from 'sweetalert2';
import { useIntl } from 'react-intl';
import { checkWhatsapp } from '../../../../api/Whatsapp';
import { insertMerchantWithTemplate } from '../../../../api/MerchantsCRUD';
import useAccessToken from '../../../../hooks/AccessToken';
import { mutate } from 'swr';
import { usePipelineStore } from '../../../../stores/PipelineStore';
import { currencyFormatter, getLongitudeLatitude } from '../../../../functions/general';
import useUser from '../../../../hooks/User';
import { useMerchantStore } from '../../../../stores/MerchantStore';
import { useMeetingStore } from '../../../../stores/MeetingsStore';
import { useUserStore } from '../../../../stores/UserStore';
import moment from 'moment-timezone';
import { getCustomFieldsValues } from '../../../../functions/ExportTemplateExcel/functionHelperExcel';
import { Label } from '../../../../interfaces/Label';
import { UserCompany } from '../../../../interfaces/UserCompany';
import { getListIdParticipant } from '../../../../functions/ExportTemplateExcel/helperTemplateExcel';
import { getListIdLabel } from '../../../../functions/ExportTemplateExcel/helperTemplateExcel';
import { insertMeeting, insertVisitMeeting } from '../../../../api/MeetingsCRUD';
import { getValidLocation } from '../../../../api/General';
import { useProductStore } from '../../../../stores/ProductStore';

interface UseHandleImportVisitMeetingProps {
    customFields: CustomField
    setListData: (data: any) => void
    templateMeetingId: string
    dataUsers: any
    dataUsersCompany: UserCompany[]
    dataSuccess: any
    dataLabel: Label[]
}

const API_URL = process.env.REACT_APP_API_URL

const useHandleImportVisitMeeting = ({ customFields, setListData, templateMeetingId, dataUsers, dataUsersCompany, dataLabel, dataSuccess }: UseHandleImportVisitMeetingProps) => {
    const intl = useIntl()
    const token = useAccessToken()
    const { simplePipelines } = usePipelineStore()
    const { simpleMerchants } = useMerchantStore()
    const { simpleMeetings } = useMeetingStore()
    const { simpleProducts } = useProductStore()

    const { users } = useUserStore()
    const user = useUser()

    const handleChangeVisitMeeting = async (e: any) => {
        setListData([]);
        var check_excel = true;
        var empty_excel = false;
        var success = false;
        const file = e;
        const wb = new ExcelJS.Workbook();
        const reader = new FileReader();

        var filteredCustomFieldMeeting = Object.fromEntries(
            Object.entries(customFields).filter(([key, value]) => {
                return value && typeof value === 'object' && value.type !== 'serial'
            })
        );

        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const buffer: any = reader.result;
            wb.xlsx.load(buffer).then((workbook: any) => {
                const newData: any = [];
                var nameWorksheet = workbook.getWorksheet("Sheet1")
                var nameWorksheetInfo = workbook.getWorksheet("Info")
                if (nameWorksheetInfo !== undefined) {
                    nameWorksheetInfo.eachRow(async (rowInfo: any, rowIndexInfo: number) => {
                        if (rowIndexInfo > 3) {
                            if (rowInfo.values[2] === `Template Insert Visit Meeting ${templateMeetingId}` || rowInfo.values[2] === `Template Error Insert Visit Meeting ${templateMeetingId}`) {
                                nameWorksheet?.eachRow(async (row: any, rowIndex: number) => {
                                    if (rowIndex > 2) {
                                        const rowData = row.values
                                        if (Array.isArray(rowData)) {
                                            const getMaplocationValidType = typeof rowData[4] === 'object' ? rowData[4].text : rowData[4]
                                            let picId = dataUsers.find((data: any) => data.name === rowData[1])?.id || null
                                            let merchantId = simpleMerchants.find((data: any) => data.name === rowData[2])?.id || null
                                            const listIdLabel = getListIdLabel(dataLabel, rowData[3]).map((label: any) => { return { id: label } }) || null
                                            let { latitude, longitude, locationName } = getLongitudeLatitude(getMaplocationValidType)
                                            const getAttachments = rowData[6] ? typeof rowData[6] === 'object' ? rowData[6].text : rowData[6] : null

                                            const customFieldsStartIndex = 7; // mulai dari kolom ke 6 untuk custom field
                                            const customFieldsData = Object.fromEntries(Object.keys(filteredCustomFieldMeeting).map((key, index) => {
                                                const rowIndex = customFieldsStartIndex + index;
                                                const rowValue = rowData[rowIndex];
                                                const fieldType = filteredCustomFieldMeeting[key].type;
                                                let fieldValue;

                                                if (fieldType === 'image' || fieldType === 'file' || fieldType === 'text' || fieldType === 'link' || fieldType === 'email' || fieldType === 'video') {
                                                    fieldValue = typeof rowValue === 'object' ? rowValue.text : rowValue;
                                                } else {
                                                    fieldValue = rowValue;
                                                }

                                                return [key, fieldValue];
                                            }));

                                            newData.push({
                                                ownerId: picId,
                                                pic_name: rowData[1],
                                                merchantId: merchantId,
                                                merchant_name: rowData[2],
                                                label_name: rowData[3],
                                                locationString: rowData[4],
                                                note: rowData[5],
                                                meetingLabels: listIdLabel,
                                                latitude: latitude,
                                                longitude: longitude,
                                                location: locationName,
                                                attachments: getAttachments,
                                                ...customFieldsData,
                                            })

                                            check_excel = true
                                            success = true
                                            empty_excel = false
                                        }
                                    } else {
                                        empty_excel = true
                                        return false
                                    }
                                });
                            } else {
                                check_excel = false
                                return false
                            }
                        }
                    })
                } else {
                    check_excel = false
                }
                if (empty_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.FILL_DATA_FIRST' }),
                        confirmButtonText: 'Ok'
                    });
                }

                if (!check_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.EXCEL_TEMPLATE_NOT_MATCHING' }),
                        confirmButtonText: 'Ok'
                    });
                }
                if (success) setListData(newData);
            });
        };
    };

    const handleInsertVisitMeeting = async (data: any) => {
        const customFieldsValues = getCustomFieldsValues(data, customFields, simplePipelines, simpleMerchants, simpleMeetings, simpleProducts, users, user)
        let newLatitude, newLongitude, newLocationName;
        const getMapValidLocation = await getValidLocation(data.location, data.latitude, data.longitude, true)
        if (getMapValidLocation.data.success) {
            newLatitude = getMapValidLocation.data.data[0].location.lat
            newLongitude = getMapValidLocation.data.data[0].location.lng
            newLocationName = getMapValidLocation.data.data[0].address

            const response = await insertVisitMeeting({
                meetingTemplateId: templateMeetingId as string,
                meetingLabels: data.meetingLabels,
                merchantId: data.merchantId,
                note: data.note,
                ownerId: data.ownerId,
                latitude: newLatitude.toString() || 0,
                longitude: newLongitude.toString() || 0,
                location: newLocationName || '',
                attachmentLink: data.attachments || '',
                token,
                customFields: customFieldsValues,
            });

            if (response.data.success) {
                mutate(`${API_URL}meetings${templateMeetingId ? `?meetingTemplateId=${templateMeetingId}` : ""}`)
                dataSuccess.push({
                    ...response.data.data,
                    lastMeetEnd: "-",
                    lastLeadCreatedTime: "-",
                    dateCreated: response.data.data.dateCreated
                })
            } else {
                // var mergeError = { ...data, error: response.data.message }
                // dataError.push(mergeError)
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong',
                confirmButtonText: 'Ok'
            });
        }
    }

    return {
        handleChangeVisitMeeting,
        handleInsertVisitMeeting
    }
}

export default useHandleImportVisitMeeting